<template>
  <div>
    <v-dialog v-model="dialogData" width="500" persistent>
      <v-card>
        <v-card-title> Move Outlet to Other Merchant </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row style="align-items: center">
                <v-autocomplete
                  id="correlationId"
                  ref="correlationId"
                  clearable
                  v-model="correlationId"
                  :items="itemsListMerchant"
                  return-object
                  item-text="text"
                  item-value="correlationId"
                  :error-messages="correlationIdErrors"
                  label="Type MID"
                  @change="$v.correlationId.$touch()"
                  @blur="$v.correlationId.$touch()"
                  :loading="isLoadingMerchant"
                  :search-input.sync="searchMerchant"
                  hide-selected
                  outlined
                />
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="cancelDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            @click="confirm"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="500" persistent>
      <confirm-dialog
        :title="'Are you sure want to do this ?'"
        v-on:closeCancelParent="close"
        v-on:confirmParent="save"
      />
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { date, showAlert } from '../../lib/helpers';

export default {
  components: {
    confirmDialog: () => import('../ConfirmDialog.vue'),
  },
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    dialogOtoOM: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: null,
    },
  },
  mixins: [validationMixin],
  validations: {
    correlationId: { required },
  },
  data: () => ({
    dialog: false,
    correlationId: null,
    searchMerchant: '',
    isLoadingMerchant: false,
  }),
  computed: {
    dialogData() {
      return this.dialogOtoOM;
    },
    errorValidation() {
      return this.$store.state.outletManagement.errors;
    },
    loading() {
      return this.$store.state.outletManagement.loading;
    },
    correlationIdErrors() {
      const errors = [];
      if (!this.$v.correlationId.$dirty) return errors;
      if (!this.$v.correlationId.required) errors.push('merchant is required');
      if (!this.$v.correlationId.isRegistered) {
        if (this.errorValidation.correlationId != null) {
          this.errorValidation.correlationId.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    itemsListMerchant() {
      return this.$store.state.outletManagement.listMerchant;
    },
  },
  watch: {
    searchMerchant: {
      handler(val) {
        if (val != null) {
          this.getMerchant();
        }
      },
    },
    correlationId: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.correlationId != null &&
            val != this.errorValidation.correlationId
          ) {
            this.$store.commit('register/clearErrorVariable', 'correlationId');
          }
        }
      },
    },
  },
  methods: {
    cancelDialog() {
      this.$emit('closeCancelParent');
    },
    resetUniqueValidation() {
      this.$store.commit('outletManagement/clearErrors');
    },
    confirm() {
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.dialog = true;
      }
    },
    close() {
      this.dialog = false;
    },
    async getMerchant() {
      this.isLoadingMerchant = true;
      await this.$store.dispatch('outletManagement/getMerchant', {
        query: this.searchMerchant == null ? '' : this.searchMerchant,
        date,
      });
      this.isLoadingMerchant = false;
    },
    async save() {
      this.dialog = false;
      this.$store.commit('outletManagement/setFlashErrorMessage', '');

      const outlet = {
        id_outlet: this.editedItem.id,
        core_merchant: this.correlationId.correlation_id,
      };

      await this.$store
        .dispatch('outletManagement/updateOutlettoOM', {
          date,
          outlet,
          index: this.editedIndex,
        })
        .then((status) => {
          if (status) {
            this.$emit('closeCancelParent');
            this.$emit('fetchDataParent');
            showAlert(
              this.$store,
              'Update outlet success !',
              'mdi-check-circle',
              'green'
            );
          } else {
            showAlert(
              this.$store,
              'Error on update outlet !',
              'mdi-alert',
              'red'
            );
          }
        });
    },
  },
};
</script>
